import React from 'react';
import { OneLineInput } from '../⚛️atoms/OneLineInput';
import Dropzone from 'react-dropzone';
import { cloneWorkbookV2Value } from './editorUtils';

export const WorkbookV2Image = ({ item, updateItem, editing, uploadImage }) => {
  const updateEditorItem = (updates) => {
    const nextItem = cloneWorkbookV2Value(item);
    nextItem.text = updates.text ?? nextItem.text;
    nextItem.page_number = updates.page_number ?? nextItem.page_number;
    updateItem(nextItem);
  };

  return (
    <div
      className={`flex w-full items-center justify-center gap-2 ${editing && 'border-pdteal rounded-lg border-2 px-8 py-12'}`}
    >
      {!editing && <img src={`${process.env.REACT_APP_API_URL}/${item.options?.image_path}`} alt={item.text} />}
      {editing && (
        <div className="flex w-full flex-col items-center gap-8">
          <OneLineInput label="Alt" value={item.text} onChange={(value) => updateEditorItem({ text: value })} />
          <div className="w-1/5 self-start">
            <OneLineInput
              value={item.page_number}
              label="Page Number"
              onChange={(value) => updateEditorItem({ page_number: value })}
            />
          </div>
          <Dropzone onDrop={(acceptedFiles) => uploadImage(acceptedFiles)} accept={{ 'image/jpeg': ['.jpeg', '.png'] }}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div className="rounded-lg border-1 border-dashed border-gray-300 p-10" {...getRootProps()}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              </section>
            )}
          </Dropzone>
        </div>
      )}
    </div>
  );
};
